<!-- تحسين الهيكل مع إضافة تأثيرات حركية وتنسيق عصري -->
<div class="row g-4"> <!-- استخدام g-4 لمسافات متساوية بين البطاقات -->
  @for(data of blogData; track $index){
    <div class="col-lg-4 col-md-6">
      <div class="card blog-card h-100 border-0 shadow-sm transition-all">
        <!-- قسم الصورة مع تأثير التكبير عند التمرير -->
        <div class="position-relative overflow-hidden rounded-top">
          <img 
            [src]="data.IMGUrl" 
            class="card-img-top blog-img" 
            alt="{{ currentLang == 'ar' ? data.TiteleAr : data.TiteleEn }}"
            loading="lazy"
          >
          <!-- طبقة شفافة فوق الصورة لإبراز النص (اختياري) -->
          <div class="overlay-gradient"></div>
        </div>

        <!-- محتوى البطاقة -->
        <div class="card-body d-flex flex-column">
          <!-- العنوان -->
          <h5 class="card-title mb-2">
            <a 
              routerLink="/blog-detail/{{data.Id}}" 
              class="text-dark text-decoration-none stretched-link title-link"
            >
              {{ currentLang == 'ar' ? data.TiteleAr : data.TiteleEn }}
            </a>
          </h5>

          <!-- بيانات إضافية (التفاعلات + زر القراءة) -->
          <div class="d-flex justify-content-between align-items-center mt-auto pt-3 border-top">
            <div class="post-meta d-flex gap-3">
              <!-- عدد الإعجابات -->
              <!-- <span class="text-muted small">
                <i class="uil uil-heart text-danger me-1"></i>
                {{ data.like || 0 }}
              </span> -->
              <!-- عدد التعليقات -->
              <!-- <span class="text-muted small">
                <i class="uil uil-comment text-primary me-1"></i>
                {{ data.message || 0 }}
              </span> -->
            </div>
            <!-- زر قراءة المزيد -->
            <a 
              routerLink="/blog-detail/{{data.Id}}" 
              class="btn btn-link btn-sm text-primary fw-semibold p-0 readmore-link"
            >
              {{ 'Read More' | translate }}
              <i class="uil uil-arrow-right ms-1" *ngIf="currentLang != 'ar'"></i>
              <i class="uil uil-arrow-left ms-1" *ngIf="currentLang == 'ar'"></i>

            </a>
          </div>
        </div>

        <!-- تذييل البطاقة (الكاتب والتاريخ) -->
        <div class="card-footer bg-transparent border-0 d-flex justify-content-between align-items-center text-muted small pt-0">
          <span>
            <i class="uil uil-user me-1"></i>
            {{ currentLang == 'ar' ? data.TiteleAr : data.TiteleEn }}
          </span>
          <span>
            <i class="uil uil-calendar-alt me-1"></i>
            {{ data.createDate | date: 'dd/MM/yyyy' }}
          </span>
        </div>
      </div>
    </div>
  }
</div>